/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
import {
    ChunkedListBase,
    ChunkedListBaseFromJSON,
    ChunkedListBaseFromJSONTyped,
    ChunkedListBaseToJSON,
    UpsSummary,
    UpsSummaryFromJSON,
    UpsSummaryFromJSONTyped,
    UpsSummaryToJSON,
    UpsSummaryChunkAllOf,
    UpsSummaryChunkAllOfFromJSON,
    UpsSummaryChunkAllOfFromJSONTyped,
    UpsSummaryChunkAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpsSummaryChunk
 */
export interface UpsSummaryChunk {
    /**
     * 
     * @type {number}
     * @memberof UpsSummaryChunk
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof UpsSummaryChunk
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof UpsSummaryChunk
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof UpsSummaryChunk
     */
    pageCount: number;
    /**
     * 
     * @type {Array<UpsSummary>}
     * @memberof UpsSummaryChunk
     */
    chunk: Array<UpsSummary>;
}

export function UpsSummaryChunkFromJSON(json: any): UpsSummaryChunk {
    return UpsSummaryChunkFromJSONTyped(json, false);
}

export function UpsSummaryChunkFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsSummaryChunk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'size': json['size'],
        'totalCount': json['totalCount'],
        'pageCount': json['pageCount'],
        'chunk': ((json['chunk'] as Array<any>).map(UpsSummaryFromJSON)),
    };
}

export function UpsSummaryChunkToJSON(value?: UpsSummaryChunk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'size': value.size,
        'totalCount': value.totalCount,
        'pageCount': value.pageCount,
        'chunk': ((value.chunk as Array<any>).map(UpsSummaryToJSON)),
    };
}


